module.exports = __webpack_public_path__ + "static/media/wd2.46065b5e.svg";